import type { AvailableSlot } from "@kuroo/contracts";
import { escapeHtml } from "./booking-utils";

export interface BookingSlotsMarkupOptions {
  failed?: boolean;
  waitlistEnabled: boolean;
  serviceId?: string;
  formatSlot: (slot: AvailableSlot) => string;
  renderSlotPrice: (slot: AvailableSlot) => string;
}

export function renderBookingSlotsMarkup(slots: AvailableSlot[], options: BookingSlotsMarkupOptions): string {
  if (options.failed) return '<div class="alert">No se pudo cargar la disponibilidad. <button type="button" data-retry>Reintentar</button></div>';
  if (!slots.length) {
    const waitlist = options.waitlistEnabled && options.serviceId
      ? '<button type="button" class="secondary-button" data-action="open-waitlist">Avisarme si se libera un horario</button><div class="waitlist-panel" data-waitlist-panel hidden><p>Dejanos un email y te avisaremos si aparece disponibilidad.</p><div class="waitlist-actions"><label class="field">Email<input type="email" data-waitlist-email autocomplete="email" required /></label><label class="field">Personas<input type="number" data-waitlist-persons min="1" max="52" value="1" required /></label><button type="button" class="primary-button" data-action="join-waitlist">Anotarme</button></div><p class="waitlist-status" data-waitlist-status role="status" aria-live="polite"></p></div>'
      : "";
    return `<div class="slots-empty">Sin horarios para esta fecha.${waitlist ? `<div style="display:grid;gap:.5rem;margin-top:.7rem">${waitlist}</div>` : ""}</div>`;
  }
  const groups = new Map<string, AvailableSlot[]>();
  slots.forEach((slot) => {
    const key = `${slot.providerName ?? "Profesional"} · ${slot.locationName ?? "Sede sin asignar"}`;
    groups.set(key, [...(groups.get(key) ?? []), slot]);
  });
  return [...groups.entries()].map(([label, entries]) => `<div class="slot-group"><strong>${escapeHtml(label)}</strong><small>${escapeHtml(entries[0]?.timezone ?? "UTC")}</small><div class="slot-list">${entries.map((slot) => {
    const slotIndex = slots.indexOf(slot);
    const slotPrice = options.renderSlotPrice(slot);
    return `<button type="button" class="slot" data-slot-index="${slotIndex}" data-slot-key="${escapeHtml(slot.slotKey)}">${options.formatSlot(slot)}${slot.remainingCapacity > 1 ? ` · ${slot.remainingCapacity} libres` : ""}${slotPrice ? `<span class="slot-price"> · ${slotPrice}</span>` : ""}</button>`;
  }).join("")}</div></div>`).join("");
}
